@if (reviewProcessEnabled) {
<div class="return-review-container">
  @if (!loading) {

    @if (!loadError) {

      <ul class="nav nav-tabs" role="tablist">
        <!-- Static Dashboard tab — mirrors legacy return-review.dashboard state -->
        <li class="nav-item">
          <a
            class="nav-link pending"
            [class.active]="isDashboardSelected"
            [attr.aria-current]="isDashboardSelected ? 'page' : null"
            tabindex="0"
            (click)="selectDashboard()"
            (keyup.enter)="selectDashboard()"
          >
            Dashboard
          </a>
          @if (steps.length > 0) {
<span class="arrow" aria-hidden="true">
            <i class="fa fa-angle-right"></i>
          </span>
}
        </li>

        @for (step of steps; track trackByStep(i, step); let i = $index) {
<li
          class="nav-item"
         
        >
          <a
            class="nav-link"
            [ngClass]="[statusClass(step), isSelected(step) ? 'active' : '']"
            [title]="tooltipForStep(step)"
            [attr.aria-current]="isSelected(step) ? 'page' : null"
            tabindex="0"
            (click)="selectStep(step)"
            (keyup.enter)="selectStep(step)"
          >
            <i [ngClass]="statusIcon(step)" aria-hidden="true"></i>
            <span class="step-name">{{ shortStepLabel(step) }}</span>
            @if (step.STEP_STATUS === 'IGNORED') {
<i
              class="fa fa-asterisk"
             
              aria-hidden="true"
            ></i>
}
          </a>
          @if (i < steps.length - 1) {
<span class="arrow" aria-hidden="true">
            <i class="fa fa-angle-right"></i>
          </span>
}
        </li>
}

        @if (showIgnoreButton) {
<li class="nav-item ignore-tab">
          <a
            class="nav-link resolved"
            tabindex="0"
            (click)="openIgnoreOverlay()"
            (keyup.enter)="openIgnoreOverlay()"
          >
            <i class="fa fa-low-vision" aria-hidden="true"></i>
            Ignore
          </a>
        </li>
}
      </ul>

      <div class="content-view">

        @if (isDashboardSelected) {
<gtw-efile-return-review-dashboard
         
          [steps]="steps"
          [loading]="loading && steps.length === 0"
          [refreshing]="dashboardRefreshing"
          [loadError]="loadError"
          [exporting]="exporting"
          [irsFilter]="dashboardIrsFilter"
          [irsFilterLoading]="dashboardIrsFilterLoading"
          [irsFilterUserPicked]="dashboardIrsUserPicked"
          (exportRequested)="exportReturnReview()"
          (refreshRequested)="refreshDashboard()"
          (irsFilterChange)="onDashboardIrsFilterChange($event)"
          (irsFilterReload)="reloadDashboardIrsFilter()"
          (rowSelected)="openDashboardRow($event)"
        ></gtw-efile-return-review-dashboard>
}

        @if (!isDashboardSelected) {

        @if (selectedStateUrl) {

          <!--
            Lazy per-step content host. Mirrors legacy ui-router semantics
            (`<div ui-view>` in return-review.html L151) where switching
            child states destroys the previous template and creates the
            new one. Mounting a single host keyed on `selectedStateUrl`
            ensures every grid is initialised in a properly-sized
            container — gizmoGrid's column-width / virtual-scroll math
            silently breaks when computed against a `display: none`
            (zero height/width) host, which was the root cause of the
            "tab clicks but the grid never appears" symptom.

            `*ngFor` over `[selectedStateUrl]` with `trackBy` is a
            structural-directive trick that forces Angular to destroy
            and recreate the embedded view whenever the key changes —
            this in turn re-runs the `efileGrid` directive's
            `ngAfterViewInit` so the new step's gizmoGrid mounts fresh
            with the correct `[gridConfig]`.
          -->
          @for (key of [selectedStateUrl]; track trackByKey($index, key)) {

            @if (isCurrentStepValidation()) {

              <!--
                Validation / errors step (legacy
                `submissions-dasboard.submission.return-review.validation`,
                URL `/errors`). Renders the migrated form-list + per-form
                gizmoGrid panel.
              -->
              <gtw-efile-validation-errors
                class="step-validation-host"
                [step]="currentStep()"
                (stepsReload)="onStepsReload()"
              ></gtw-efile-validation-errors>
            
} @else {

              @if (currentGridConfig(); as cfg) {

                <!--
                  Tab-level filter bar (mirrors legacy
                  `app/components/efile/efileElements/grid-tpl.html`
                  L2-L22 — refresh icon + per-filter dropdown + Filter
                  button). Rendered only for steps that declare filters
                  in `RETURN_REVIEW_GRID_CONFIGS` (today: xml-vs-elements
                  and xml-vs-elements-counts, both gated on the
                  IRS Submissions dropdown).

                  The grid host is always declared so its `#gridRef`
                  template variable stays in scope of the Filter button
                  even while the gating placeholder is shown — we just
                  toggle the host's visibility via `[hidden]`. When the
                  user lands on a tab with a required filter unset, the
                  directive's `ngAfterViewInit` still mounts gizmoGrid
                  scaffolding (with `autoLoad: false` from
                  `buildGridConfig`), so the very first Filter click can
                  flip in-place via `gridRef.refresh(extraParams)`.
                -->
                <!--
                  Legacy `grid-tpl.html`: one row — refresh, filter dropdown(s),
                  green Filter button (no separate label; placeholder in control
                  shows e.g. "IRS Submissions").
                -->
                @if (currentFilterSpecs().length > 0) {
<div
                  class="gt-filter-container"
                 
                >
                  <div class="filter-col filter-refresh">
                    @if (isCurrentFiltersLoading()) {
<i
                     
                      class="fa fa-spinner fa-spin gt-refresh"
                      aria-hidden="true"
                    ></i>
}
                    @if (!isCurrentFiltersLoading()) {
<i
                     
                      class="fa fa-refresh gt-refresh"
                      role="button"
                      tabindex="0"
                      (click)="applyFilters(gridRef || null)"
                      (keyup.enter)="applyFilters(gridRef || null)"
                      title="Refresh Data"
                      aria-label="Refresh data"
                    ></i>
}
                  </div>

                  @if (!isCurrentFiltersLoading()) {

                    @for (filter of currentFilters(); track trackByFilter($index, filter)) {
<div
                      class="filter-col filter-dropdown"
                     
                    >
                      <div
                        df-select-single
                        [attr.aria-label]="filter.label"
                        [filter]="filter"
                        (filterChange)="onFilterValueChange($event)"
                      ></div>
                    </div>
}
                    <div class="filter-col filter-action">
                      <button
                        type="button"
                        class="filter-button"
                        [disabled]="isFilterButtonDisabled()"
                        (click)="applyFilters(gridRef || null)"
                      >
                        Filter
                      </button>
                    </div>
                  
}
                </div>
}

                @if (isCurrentGridGatedByFilters()) {
<div
                  class="step-placeholder"
                 
                >
                  <div class="step-placeholder__hint">
                    Please select the required filter(s) above and click
                    <strong>Filter</strong> to load the grid.
                  </div>
                </div>
}

                <div
                  class="step-grid-host"
                  [class.step-grid-host--efile-diagnostics]="isEfileDiagnosticsGridStep()"
                  [hidden]="isCurrentGridGatedByFilters()"
                >
                  <!--
                    NOTE: a `.grid-empty-overlay` card ("No records to
                    display.") used to render here on top of the gizmoGrid
                    scaffold whenever the loaded payload was empty. That
                    overlay was 94%-opaque white over the entire host, so
                    the toolbar, scrollbars and footer all looked faded
                    under it (see Return Review screenshot in the bug
                    report). Removed in favour of gizmoGrid's native empty
                    state — the directive renders the toolbar + empty
                    `.gg-body` + `Total Records: 0` footer chrome with no
                    extra messaging, matching the legacy AngularJS UI.
                    `isReturnReviewGridEmpty()` /
                    `gridRowCountByStateUrl` are intentionally kept on the
                    component class for future per-step empty-state needs
                    (e.g. step badges that need to know zero-row state).
                  -->
                  <div
                    efileGrid
                    #gridRef="efileGrid"
                    class="gizmo-grid"
                    [gridConfig]="cfg"
                    (gridCallback)="onGridCallback($event, gridRef)"
                    (gridDataLoaded)="onReturnReviewGridDataLoaded($event)"
                  ></div>
                </div>
              
} @else {

                <div class="step-placeholder">
                  <div class="step-placeholder__title">
                    Step: {{ shortStepLabel(currentStep()) }}
                  </div>
                  <div class="step-placeholder__state">
                    <span class="label">Legacy state</span>
                    <code>{{ selectedStateUrl }}</code>
                  </div>
                  <div class="step-placeholder__hint">
                    No return-review grid is registered for this step (missing
                    from RETURN_REVIEW_GRID_CONFIGS). If you expected a grid here,
                    add its grid_id / action mapping in
                    efile-return-review.component.ts.
                  </div>
                </div>
              
}

              
            
}

            
          
}
        
} @else {

          <div class="step-placeholder">
            <div class="step-placeholder__hint">
              No workflow steps available for this submission.
            </div>
          </div>
        
}

        
        
}<!-- /!isDashboardSelected -->
      </div>
    
} @else {

  <div class="return-review-error">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    {{ loadError }}
    <button type="button" class="retry-btn" (click)="loadSteps()">Retry</button>
  </div>

}
  
} @else {

  <div class="return-review-loading">
    <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
    Loading workflow steps…
  </div>

}

  <!-- Confirmation modal for ctrlFn plans (sub-sno-disable / sub-req-validations / ...) -->
  @if (showConfirmModal) {
<gtw-confirmation-modal
   
    [config]="confirmModalConfig"
    [visible]="showConfirmModal"
    (confirmed)="onConfirmModal()"
    (cancelled)="onCancelModal()"
    (closed)="onCancelModal()"
  ></gtw-confirmation-modal>
}

  <!-- Ignore overlay (inline, mirrors ignore-modal-tpl.html) -->
  @if (showIgnoreOverlay) {
<div class="ignore-overlay">
    <div class="ignore-overlay__dialog">
      <div class="modal-header">
        <h3 class="modal-title">Add Explanation</h3>
        <div class="header-actions">
          <i
            class="fa fa-times"
            role="button"
            tabindex="0"
            (click)="cancelIgnoreOverlay()"
            (keyup.enter)="cancelIgnoreOverlay()"
          ></i>
        </div>
      </div>
      <div class="modal-body clearfix">
        <label for="ignore-explanation">Please add an explanation:</label>
        <textarea
          id="ignore-explanation"
          class="form-control"
          rows="4"
          [ngModel]="ignoreExplanation"
          (ngModelChange)="onIgnoreExplanationChange($event)"
          [disabled]="ignoreSubmitting"
        ></textarea>
      </div>
      <div class="modal-footer">
        <button class="cancel-button" type="button" (click)="cancelIgnoreOverlay()">Cancel</button>
        <button
          class="save-button"
          type="button"
          [disabled]="!ignoreExplanation || ignoreSubmitting"
          (click)="submitIgnoreOverlay()"
        >
          @if (ignoreSubmitting) {

            <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i> Saving...
          
} @else {
Save
}
          
        </button>
      </div>
    </div>
  </div>
}
</div>
} @else {

  <div class="return-review-disabled">
    <i class="fa fa-lock" aria-hidden="true"></i>
    Return review process is not enabled for the current user.
  </div>

}






